import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, LOCALE_ID } from '@angular/core';
import {DatePipe, DecimalPipe} from '@angular/common';
import { ConverterUtils } from './converter.utils';
declare let pdfMake: any;
const apiUrl = 'assets/templatePDFMake/';


@Injectable()
export class ExportBonCommandeService {

  private decimalPipe: DecimalPipe;

  constructor(
    private datePipe: DatePipe,
    private converterUtils: ConverterUtils,
    decimalPipe: DecimalPipe,
    private http: HttpClient,
    @Inject(LOCALE_ID) public locale: string
  ) {
    this.decimalPipe = decimalPipe;
  }

  loadConfig(filename: string) {
    const url = `${apiUrl}/` + filename;
    return this.http.get<any>(url);
  }

  export(document, bonLivraisons, print = false) {
    let jsonFile = 'bonCommande.json';

    this.loadConfig(jsonFile)
      .subscribe(docDefinition => {
        let optionStr = JSON.stringify(docDefinition);
        const startDate = this.datePipe.transform(document.startDate, 'dd-MM-yyyy');
        const endDate = this.datePipe.transform(document.endDate, 'dd-MM-yyyy');
        const quantity = document.quantity;

        optionStr = this.unsafeRedactName(optionStr, 'startDate' , startDate);
        optionStr = this.unsafeRedactName(optionStr, 'endDate' , endDate);
        optionStr = this.unsafeRedactName(optionStr, 'matriculeFiscale' , '1817344TPM000');
        optionStr = this.unsafeRedactName(optionStr, 'num' , document.num);
        optionStr = this.unsafeRedactName(optionStr, 'natureBC' , document.natureBC);
        optionStr = this.unsafeRedactName(optionStr, 'naturePrix' , document.naturePrix);
        optionStr = this.unsafeRedactName(optionStr, 'quantity' , document.quantity);
        optionStr = this.unsafeRedactName(optionStr, 'beneficiary' , document.beneficiary);
        optionStr = this.unsafeRedactName(optionStr, 'product' , document.product ? document.product.name : '');
        optionStr = this.unsafeRedactName(optionStr, 'centreLivraison' , document.centreLivraison ? document.centreLivraison.name : '');

        docDefinition = JSON.parse(optionStr);


        let totauxBL = 0;
        let totauxBR = 0;

        for (let i = 0; i < bonLivraisons.length; i++) {

          const bl = bonLivraisons[i];

          const row = [
            {
              'text': bl.numBL,
              'style': 'tableContent',
              'border': [true, true, true, true]

            }, {
              'text': bl.numBR_office,
              'style': 'tableContent',
              'border': [true, true, true, true]

            }, {
              'text': this.datePipe.transform(bl.dateBL, 'dd-MM-yyyy'),
              'style': 'tableContent',
              'border': [true, true, true, true]

            }, {
              'text':  bl.quantityBL ? bl.quantityBL.toFixed(2) : 0,
              'style': 'tableContent',
              'border': [true, true, true, true]

            }, {
              'text':  bl.quantityBR_office ? bl.quantityBR_office.toFixed(2) : 0,
              'style': 'tableContent',
              'border': [true, true, true, true]

            }, {
              'text': bl.transporteur,
              'style': 'tableContent',
              'border': [true, true, true, true]

            }];
          docDefinition.content[4].table.body.push(row);

          totauxBL += bl.quantityBL ? bl.quantityBL : 0;
          totauxBR += bl.quantityBR_office ? bl.quantityBR_office : 0;
        }

        let rowTotaux = [
          {
            text: '',
            style: 'tableContent',
            border: [
              true,
              false,
              false,
              true
            ]
          },
          {
            text: '',
            style: 'tableContent',
            border: [
              false,
              false,
              false,
              true
            ]
          },
          {
            text: 'TOTAL',
            bold: true,
            style: 'tableContent',
            border: [
              false,
              false,
              true,
              true
            ]
          },
          {
            text: totauxBL ? totauxBL.toFixed(2) : 0,
            style: 'tableContent',
            border: [
              false,
              false,
              true,
              true
            ]
          },
          {
            text: totauxBR ? totauxBR.toFixed(2) : 0,
            style: 'tableContent',
            border: [
              false,
              false,
              false,
              true
            ]
          },
          {
            text: '',
            style: 'tableContent',
            border: [
              true,
              false,
              false,
              false
            ]
          }
        ];

        docDefinition.content[4].table.body.push(rowTotaux);

        //console.log(JSON.stringify(docDefinition));

        if (print) {
          pdfMake.createPdf(docDefinition).print();
        } else {
          pdfMake.createPdf(docDefinition).download('BON_COMMANDE_' + document.num + '.pdf');
        }
      }, err => {
        // this.toastr.error(`Une erreur s'est produite lors de l'enregistrement` + ': ' + err,  `Erreur`);
      });
  }

  unsafeRedactName(text, name, by) {
    return text.replace(new RegExp('\\$\\{' + name + '\\}', 'g'),  by );
  }

}
